<template>
  <div class="card main-content">
    <div class="grid mt-3">
        
        <div class="sm:col-12 md:col-2 lg:col-2 mr-1 ml-4">
            <div>
              <Card >
                <template #title>Item:</template>
                  <template #content>
                    <div>
                      <label v-if="itemName" class="text-lg">{{itemName}}</label>
                      <Skeleton v-if="!itemName" width="10rem" height="2rem" class="mr-2"></Skeleton>
                    </div>
                  </template>
              </Card>
            </div>
            <div class="mt-5">
              <Card>
                <template #title>Quantity</template>
                  <template #content>
                      <!-- <div >
                      </div> -->
                      <div class="flex">
                        <Skeleton v-if="itemQty==0" width="4rem" height="2rem" class="mr-2"></Skeleton>
                        <label v-if="itemQty>0" class="mr-2">{{formatNumber(itemQty)}}</label> 
                        <Tag v-if="itemQty>0" value="In Stock" severity="success"/>
                        <Tag v-if="itemQty==0" value="Out of Stock" severity="danger"/>
                      </div>
                  </template>
              </Card>
            </div>
        </div>
        <div class=" sm:col-12 md:col-9 lg:col-9 ml-3">
            <div class="flex justify-content-between flex-wrap ml-3">
                <div class="flex align-items-center justify-content-center ">
                    <!-- <InputText v-model="searchQuery" placeholder="Search item" class="w-full mr-2" />
                    <Button icon="pi pi-search" class="px-3" raised @click="searchItem"/> -->
                    <Button label="Full Details" icon="pi pi-list" severity="info" raised @click="fullDetails"/>
                </div>
                <div class="flex align-items-center justify-content-center 2">
                  <Button label="Back to Stocks" icon="pi pi-angle-left" severity="secondary" raised @click="$router.back()"/>
                </div>
            </div>
            <div class="ml-3 mt-3 ">

                  <div class="surface-card shadow-2 p-3 border-round-xl w-full mt-4 h-full">
                    <DataTable ref="detailedLog" :value="recdStockDetails" sortMode="multiple" size="small" :loading="tableLoading" exportFilename="Item_receival_details" tableStyle="min-width: 58vw"  dataKey="id" paginator :rows="100" :rowsPerPageOptions="[50, 100, 500, 1000]" paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink" currentPageReportTemplate="{first} to {last} of {totalRecords}" scrollable scrollHeight="75vh" stripedRows>

                      <template #header>
                        <div class="flex flex-wrap align-items-center justify-content-between gap-2 mb-2">
                          <div class="flex align-items-center justify-content-center">
                            <span class="text-xl text-900 font-bold">Detailed Log:</span>
                          </div>
                          <div class="flex align-items-center justify-content-center">
                            <!-- <Button label="Full Details" icon="pi pi-list" severity="info" raised @click="fullDetails"/> -->
                            <!-- <Calendar class="mr-2" v-model="recdDateRange" selectionMode="range" :manualInput="false" placeholder="Select PO date range" /> -->

                            <Button icon="pi pi-download" label="Export" size="small" raised class="mx-2" @click="exportLogData($event)" v-tooltip.top="'Export CSV'"/>
                          </div>
                        </div>
                      </template>

                      <Column header="Sl No." style="width:5%" >
                        <template #body="slotProps">
                            {{ slotProps.index  + 1}}
                        </template>
                      </Column>
                      <Column field="recdDate" header="Recd Date" style="width:8%" ></Column>
                      <Column field="manufacturer" header="Manufacturer"></Column>
                      <Column field="recdQuantity" header="Recd Quantity">
                        <template #body="slotProps">
                          {{formatNumber(slotProps.data.recdQuantity)}}
                        </template>
                      </Column>
                      <Column field="availableQty" header="Avail Qty">
                        <template #body="slotProps">
                          {{formatNumber(slotProps.data.availableQty)}}
                        </template>
                      </Column>
                        <Column header="Delivered Qty">
                          <template #body="slotProps">
                            {{formatNumber(slotProps.data.recdQuantity - slotProps.data.availableQty)}}
                          </template>
                      </Column>                  
                      <Column field="mot" header="MoT"></Column>
                      <!-- <Column field="recdAt" header="Recd at"></Column> -->
                      <!-- <Column field="checkedBy" header="Checked/Recd By"></Column> -->
                      <Column field="invoiceDetails" header="Details" :exportable="false">
                        <template #body="slotProps">
                          <Button  icon="pi pi-window-maximize" size="small" raised @click="showDetailDialog(slotProps.data)"/>
                        </template>
                      </Column>
                    </DataTable>
                  </div>

                <!-- </div> -->
    
              <!-- </div> -->
              
            </div>
        </div>
    </div>

    <!-- item details dialog -->
    <Dialog :visible="itemDetailsVisibility" modal :closable="false" :header="itemDetailsHeader" :style="{ width: '95rem' }" :breakpoints="{ '1199px': '75vw', '575px': '90vw' }">

          <div class="grid">
              <div class="col">
                <div>
                  <label class="font-medium mr-2">Received:</label>
                  <label class="mr-7">{{formatNumber(totalRecd)}}</label>

                  <label class="font-medium mr-2">Delivered:</label>
                  <label class="mr-7">{{formatNumber(totalDelivered)}}</label>


                  <label class="font-medium mr-2">Available:</label>
                  <label class="mr-7">{{formatNumber(totalAvailable)}}</label>
                </div>

              </div>
              <div class="col">
                  <div class="text-right">
                    <Button icon="pi pi-download" size="small" raised class="mx-2" @click="exportDetailsData($event)" v-tooltip.top="'Export CSV'"/>
                    <InputText v-model="filters2['global'].value" placeholder="Keyword search" />
                  </div>
              </div>
          </div>
          
          <div class="flex">
              <div class="flex align-items-center justify-content-center pr-3">
                <DataTable ref="itemBifurcationDetails" :value="invoiceDetails" size="small" :loading="table2Loading" exportFilename="Item_invoice_bifurcation_details" v-model:filters="filters2" showGridlines  tableStyle="min-width: 90rem"  dataKey="id" paginator :rows="100" :rowsPerPageOptions="[100, 500, 1000]" paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink" currentPageReportTemplate="{first} to {last} of {totalRecords}" scrollable scrollHeight="30vh" stripedRows >
                      <Column header="Sl No." >
                          <template #body="slotProps">
                              {{slotProps.index + 1}}
                          </template>
                      </Column>
                      <Column v-for="col of dialogColumns" :key="col.field" :field="col.field" :header="col.header" ></Column>
                      <Column header="Action">
                        <template #body="slotProps">
                            <Button label="DN" size="small" rounded raise v-tooltip.top="'Raise Debit Note'" @click="raiseDn(slotProps.data)"/>
                        </template>
                      </Column>

                </DataTable>
              </div>
                                            
          </div>
          <div v-if="debitNotes.length>0" class="flex">
              <div class="flex align-items-center justify-content-center pr-3">
                <DataTable :value="debitNotes" size="small" showGridlines  tableStyle="min-width: 90rem"  dataKey="id" paginator :rows="100" :rowsPerPageOptions="[100, 500, 1000]" paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink" currentPageReportTemplate="{first} to {last} of {totalRecords}" scrollable scrollHeight="30vh" stripedRows>
                  <template #header>
                    <div class="flex flex-wrap align-items-center justify-content-between gap-2">
                        <span class="text-xl text-900 font-bold">Debit Notes:</span>
                      
                    </div>
                </template>
                  <Column field="date" header="Date" ></Column>
                  <Column field="invoiceNo" header="Invoice" ></Column>
                  <Column field="voucherNo" header="Voucher" ></Column>
                  <Column field="debitQuantity" header="Qty Debited" ></Column>
                  <Column field="batch" header="Batch" ></Column>
                  <!-- <Column field="model" header="Model" ></Column> -->
                  <Column field="partSrNo" header="Part/Sr No." ></Column>
                  <Column field="rate" header="Rate" ></Column>
                  <Column field="gstRate" header="GST(%)" ></Column>
                  <Column field="exGst" header="Ex-GST" ></Column>
                  <Column field="gst" header="GST" ></Column>
                  <Column field="ewayNo" header="Eway" ></Column>
                  <Column field="remarks" header="Remarks" ></Column>
                  
                </DataTable>
              </div>
          </div>
            
          <template #footer>
              <div class="flex justify-content-end flex-wrap">
                  <Button class="my-1 py-2 mr-2" label="Close" severity="danger" size="small" @click="itemDetailsVisibility=false"/>
              </div>
          </template>      
  </Dialog>
    <!-- item details dialog end -->

    <!-- debit note dialog -->
    <Dialog :visible="debitNoteDialog" modal :closable="false" :header="debitNoteHeader" :style="{ width: '70rem' }" :breakpoints="{ '1199px': '75vw', '575px': '90vw' }">

       <div v-if="debitNoteAllowed">

        <div class="flex justify-content-between flex-wrap mb-2">
          <div class="flex align-items-center justify-content-center ">
              <div class="formgrid grid">
                <div class=" col-4">
                    <label >Name:</label>
                    <div>                      
                      <InputText v-model="debitNoteItem.name" class="w-full" disabled/>
                    </div>
                </div>
                <div class=" col-2">
                    <label >Batch:</label>
                    <div>                      
                      <InputText v-model="debitNoteItem.batch" class="w-full" disabled/>
                    </div>
                </div>
                <div class=" col-2">
                    <label >Model:</label>
                    <div>
                      <InputText v-model="debitNoteItem.modelNo" class="w-full" disabled/>
                    </div>
                </div>
                <div class=" col-2">
                    <label >Pt/Sr. No.:</label>
                    <div>
                      <InputText v-model="debitNoteItem.partNo" class="w-full" disabled/>
                    </div>
                </div>
                <div class="col-1">
                    <label >Rate:</label>
                    <div>
                      <InputText v-model="debitNoteItem.rate" class="w-full" disabled />
                    </div>
                </div>
                <div class="col-1">
                    <label >GST(%):</label>
                    <div>
                      <InputText v-model="debitNoteItem.gstRate" class="w-full" disabled />
                    </div>
                </div>
              </div>
          </div>
        </div>

        <div class="flex justify-content-between flex-wrap mb-2">
          <div class="flex align-items-center justify-content-center ">
            <div class="formgrid grid">
                <div class="field col">
                    <label >Available Quantity:</label>
                    <div>
                    <InputNumber v-model="debitNoteItem.availableQty" class="w-full" disabled/>
                    </div>
                </div>
                <div class="field col">
                    <label >Updated Quantity:</label>
                    <div>
                    <InputNumber v-model="newAvailableQty" class="w-full" disabled/>
                    </div>
                </div>
                <div class="field col">
                    <label >To be Debited:</label>
                    <div>
                    <InputNumber v-model="itemQtyDebit" class="w-full" @input="dnAmount($event)"/>
                    </div>
                </div>
                <div class="field col">
                    <label >Ex-GST:</label>
                    <div>
                    <InputNumber v-model="dnExGst" class="w-full" readonly/>
                    </div>
                </div>
                <div class="field col">
                    <label >GST:</label>
                    <div>
                    <InputNumber v-model="dnGst" class="w-full" readonly/>
                    </div>
                </div>
                <div class="field col">
                    <label >DN Date:</label>
                    <div>
                    <Calendar v-model="dnDate" class="w-full" placeholder="Debit Note date"/>
                    </div>
                </div>
                <div class="field col">
                    <label >Vch No.:</label>
                    <div>
                    <InputText v-model="vchNo" class="w-full" placeholder="Voucher No."/>
                    </div>
                </div>
                <div class="field col">
                    <label >Remarks:</label>
                    <div>
                    <InputText v-model="dnRemarks" class="w-full" placeholder="Additional note"/>
                    </div>
                </div>
            </div>

          </div>
        </div>
      </div>

      <div v-if="!debitNoteAllowed">
        <div class="justify-content-center">
          <label class="text-lg">Debit note cannot be raised as quantity is Zero (0)</label>
        </div>
      </div>

      <template #footer>
          <div class="flex justify-content-end flex-wrap">
            <Button v-if="debitNoteAllowed" class="mr-2" label="Raise DN" severity="primary" raised size="small" v-tooltip.top="'Raise Debit Note'" @click="saveDebitNote"/>
              <Button label="Close" severity="danger" size="small" @click="closeDnDialog"/>
          </div>
      </template>

    </Dialog>
    <!-- debit note dialog end -->
  </div>
</template>

<script>
import InputText from 'primevue/inputtext'
import Button from 'primevue/button'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import Card from 'primevue/card'
import Tag from 'primevue/tag'
import { getDebitNote, inventoryItemDetailLog, newDebitNote } from '@/services/apiService'
import Dialog from 'primevue/dialog'
import { FilterMatchMode } from 'primevue/api'
import Skeleton from 'primevue/skeleton'
import InputNumber from 'primevue/inputnumber'
import Calendar from 'primevue/calendar'

export default {
  components:{
    InputText,
      Button,
      DataTable,
      Column,
      Card,
      Tag,
      Dialog,
      Skeleton,
  InputNumber,
    Calendar,
    },
    data(){
      return{
        itemName:null,
        itemQty:0,
        recdStockDetails:[],
        tableLoading:false,
        itemDetailsVisibility:false,
        itemDetailsHeader:null,
        dialogColumns:[
          { field:'hsn', header:'HSN'},
          { field:'quantity', header:'Quantity' },
          { field:'availableQty', header:'Avail. Qty' },
          { field:'batch', header:'Batch' },
          { field:'mfgDate', header:'Mfg Date' },
          { field:'expDate', header:'Exp Date' },
          { field:'modelNo', header:'Model No.' },
          { field:'partNo', header:'Pt/Sr No.' },
        ],
        invoiceDetails:[],
        filters2:{
                global: { value: null, matchMode: FilterMatchMode.CONTAINS },
                batch: { value: null, matchMode: FilterMatchMode.IN },
                modelNo:{ value: null, matchMode: FilterMatchMode.IN },
                partNo: { value: null, matchMode: FilterMatchMode.IN },
            },
        totalRecd:0,
        totalDelivered:0,
        totalAvailable:0, 
        // recdDateRange:null,
        debitNoteAllowed:true,  
        debitNoteDialog:false,
        debitNoteHeader:null,
        itemQtyDebit:0,
        debitNoteItem:null,
        dnDate:null,
        vchNo:null,
        dnExGst:0,
        dnGst:0,
        dnRemarks:null,
        newAvailableQty:0,
        debitNotes:[],
      }
    },
    methods:{
      fetchItemDetails(){
        this.tableLoading = true  
        this.itemQty = 0;     
        inventoryItemDetailLog(this.$route.params.id).then((res)=>{
          this.recdStockDetails = res.data
          res.data.forEach(e => {
            this.itemQty += e.invoiceDetails.reduce((accumulator, current) => accumulator + current.availableQty, 0);
          });                
          this.itemName = res.data[0].name        
          this.tableLoading = false
        }).catch((error)=>{
          this.showErrorToast(error.response.data)
          this.tableLoading = false
        })
      },
      showDetailDialog(item){
        this.itemDetailsHeader = 'Invoice Details: '+item.name
        this.invoiceDetails = item.invoiceDetails
        this.quantityCalculator(this.invoiceDetails)
        this.itemDetailsVisibility = true
      },
      fullDetails(){
        this.invoiceDetails = []
        var invoiceItemIds = [];
        this.recdStockDetails.forEach(e => {
          e.invoiceDetails.forEach(l => {  
            invoiceItemIds.push(l.invoiceItemId);
            this.invoiceDetails.push(l);
          });
        });

        getDebitNote(invoiceItemIds).then((res)=>{
          this.debitNotes = res.data;
          
        }).catch((error)=>{
          this.showErrorToast(error.response.data);
        })

        this.quantityCalculator(this.invoiceDetails)
        this.itemDetailsHeader = 'All Invoice Details'
        this.itemDetailsVisibility = true

      },
      quantityCalculator(details){

        this.totalDelivered = 0
        this.totalRecd = 0
        this.totalAvailable = 0
        details.forEach(e => {
          this.totalRecd += e.quantity
          this.totalAvailable += e.availableQty
        });

        this.totalDelivered = this.totalRecd - this.totalAvailable
        
      },
      exportLogData(){
        this.$refs.detailedLog.exportCSV();
      },
      exportDetailsData(){
        this.$refs.itemBifurcationDetails.exportCSV();
      },
      raiseDn(item){
        if(item.availableQty > 0){
          this.debitNoteAllowed = true;
          this.debitNoteItem = item;
        }
        if(item.availableQty == 0){
          this.debitNoteAllowed = false;
        }
          this.debitNoteDialog = true;
          this.debitNoteHeader = 'Debit Note: '+item.name;        
      },
      closeDnDialog(){
        this.debitNoteDialog = false;
        this.itemQtyDebit = 0;
        this.debitNoteItem = null;
        this.newAvailableQty = 0;
        this.vchNo = null;
        this.dnRemarks = null;
        this.dnDate = null;
      },
      saveDebitNote(){
        if(this.itemQtyDebit > this.debitNoteItem.availableQty || this.itemQtyDebit==0){
          this.showErrorToast({'message':'Invalid quantity!'});
          return;
        }
        if(this.dnDate==null){
          this.showErrorToast({'message':'Date is required!'});
          return;
        }

        const data = {
          'invoiceItemId':this.debitNoteItem.invoiceItemId,
          'availableQty':this.debitNoteItem.availableQty,
          'newQty':this.itemQtyDebit,
          'newAvailableQty':this.newAvailableQty,
          'batch':this.debitNoteItem.batch,
          'model':this.debitNoteItem.modelNo,
          'partSrNo':this.debitNoteItem.partNo,
          'mfg':this.debitNoteItem.mfgDate,
          'exp':this.debitNoteItem.expDate,
          'rate':this.debitNoteItem.rate,
          'gstRate':this.debitNoteItem.gstRate,
          'exGst':this.dnExGst.toFixed(2),
          'gst':this.dnGst.toFixed(2),
          'vchNo':this.vchNo,
          'remarks':this.dnRemarks,
          'date':this.dnDate.getFullYear()+'-'+(this.dnDate.getMonth()+1)+'-'+this.dnDate.getDate(),
        }
          
        this.closeDnDialog();
        this.itemDetailsVisibility = false;
        this.tableLoading = true  
        newDebitNote(data).then((res)=>{
          this.showSuccessToast(res.data);
          this.fetchItemDetails();
        }).catch((error)=>{
          this.showErrorToast(error.response.data);
          this.tableLoading = false;
        })

        
      },
      dnAmount(event){          
          this.newAvailableQty = this.debitNoteItem.availableQty - event.value;
          this.dnExGst = event.value * this.debitNoteItem.rate;          
          this.dnGst = this.dnExGst * (this.debitNoteItem.gstRate/100);
      },
      formatNumber(value) {
        return value.toLocaleString('en-IN');
      },
      showErrorToast(error){
          this.$toast.add({ severity: 'error', summary: 'Error', detail:error.message, life: 4000 });
      },
      showSuccessToast(data){
          this.$toast.add({ severity: 'success', summary: 'Success', detail:data.message, life: 5000 });
      },  
    },
    mounted(){  
      this.fetchItemDetails();
    }
}
</script>

<style>

</style>